import { Quote, Volume2 } from "lucide-react";
import Reveal from "./Reveal";
import { useLanguage } from "../context/LanguageContext";

const Phrases = () => {
  const { t } = useLanguage();
  const p = t.phrases;

  return (
    <section className="relative overflow-hidden py-24 sm:py-32" data-testid="phrases-section">
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-br from-slate-900 via-sky-950 to-slate-900" />
      <div className="pointer-events-none absolute -top-24 start-1/4 h-96 w-96 rounded-full bg-amber-500/15 blur-3xl" />
      <div className="pointer-events-none absolute bottom-0 end-0 h-80 w-80 rounded-full bg-sky-500/15 blur-3xl" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-8">
        <div className="items-center gap-14 lg:grid lg:grid-cols-[0.9fr_1.1fr]">
          <Reveal>
            <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-400">
              {p.overline}
            </p>
            <div className="mt-4 font-heading text-7xl font-black leading-none tracking-tight sm:text-8xl lg:text-9xl">
              <span className="bg-gradient-to-br from-amber-300 via-amber-400 to-amber-600 bg-clip-text text-transparent drop-shadow-[0_0_35px_rgba(245,158,11,0.35)]">
                {p.bigNumber}
              </span>
            </div>
            <h2 className="mt-5 font-heading text-2xl font-bold leading-snug tracking-tight text-white sm:text-3xl lg:text-4xl">
              {p.title}
            </h2>
            <p className="mt-5 max-w-lg text-base leading-relaxed text-sky-100/80 sm:text-lg">
              {p.subtitle}
            </p>
            <div className="mt-7 flex items-start gap-3 rounded-2xl border border-amber-400/30 bg-amber-400/10 p-4 text-sm leading-relaxed text-amber-100">
              <Volume2 className="mt-0.5 h-5 w-5 shrink-0 text-amber-400" />
              {p.note}
            </div>
          </Reveal>

          <div className="mt-12 lg:mt-0">
            <Reveal delay={0.1}>
              <p className="mb-5 font-mono text-xs font-semibold uppercase tracking-[0.25em] text-sky-300">
                {p.samplesTitle}
              </p>
            </Reveal>
            <div className="grid gap-4 sm:grid-cols-2">
              {p.samples.map((s, i) => (
                <Reveal key={s.en} delay={0.12 + i * 0.06} y={24}>
                  <div
                    data-testid={`phrase-card-${i + 1}`}
                    className="group relative h-full overflow-hidden rounded-2xl border border-white/10 bg-white/5 p-5 backdrop-blur transition-all duration-300 hover:-translate-y-1 hover:border-amber-400/50 hover:bg-white/10"
                  >
                    <Quote className="h-4 w-4 text-amber-400/70" />
                    <p className="mt-3 font-heading text-base font-semibold leading-snug text-white sm:text-lg">
                      {s.en}
                    </p>
                    <p className="mt-2 text-xs font-bold uppercase tracking-wider text-sky-300/80">
                      {s.label}
                    </p>
                    <span className="absolute bottom-0 start-0 h-0.5 w-0 bg-gradient-to-r from-amber-400 to-sky-400 transition-all duration-500 group-hover:w-full" />
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Phrases;
